export const LOCALES = Object.freeze({
  GREEK: 'el',
  ENGLISH: 'en',
});

export const DEFAULT_LANGUAGE = LOCALES.GREEK;

// ---------------------------------------------------------------------------------------------------------------------

export const isValidLocaleValue = (locale) => {
  if (locale != null && typeof locale != 'string') {
    return false;
  }
  return Object.entries(LOCALES).some(([key, value]) => key === locale || value === locale);
};

/** @return {string} */
export const findLocaleValue = (locale) => {
  if (locale != null && typeof locale != 'string') {
    return DEFAULT_LANGUAGE;
  }
  if (Object.values(LOCALES).some((it) => it === locale)) {
    return locale;
  }
  if (Object.keys(LOCALES).some((it) => it === locale)) {
    return LOCALES[locale];
  }
  return DEFAULT_LANGUAGE;
};

export const publishNewLocale = (locale) => {
  if (!isValidLocaleValue(locale)) {
    return;
  }
  localStorage.setItem('NEW_LOCALE', locale);
  window.dispatchEvent(
    new StorageEvent('storage', {
      storageArea: localStorage,
      key: 'NEW_LOCALE',
      newValue: locale,
    })
  );
  localStorage.removeItem('NEW_LOCALE');
};

export const createStorageEventListener = (onNewLocale) => {
  return (/*StorageEvent*/ event) => {
    if (event.storageArea === localStorage && event.key === 'NEW_LOCALE' && event.newValue != null) {
      onNewLocale(findLocaleValue(event.newValue));
    }
  };
};
